import * as types from "../types/rider.types";

const initialState = {
  riderData: [],
  riderPagination: [],
  riderDetailData: [],
};

const RiderReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_RIDER_DATA:
      return { ...state, riderData: action.payload };
    case types.SET_RIDER_PAGINATION:
      return { ...state, riderPagination: action.payload };
    case types.SET_RIDER_DETAIL_DATA:
      return { ...state, riderDetailData: action.payload };
    case types.RESET_RIDER_REDUCER:
      return { 
        ...state, 
        riderData: [],
        riderPagination: [],      
        riderDetailData: [],
      };
    default:
      return state;
  }
};
export default RiderReducer;
